$(() => {
    $('body').delegate('.modal-tab-toggle', 'click', function (e) {
        e.preventDefault()

        var target = $(this).attr('data-target')
        var tabContent = $(this).attr('data-tab-content')
        $('.tab-wrap .tab-single.active').removeClass('active')
        $('.tab-content .tab-content-single.active').removeClass('active')
        $('.tab-wrap .tab-single[data-content=' + tabContent + ']').addClass('active')
        $('.tab-content .tab-content-single[data-content=' + tabContent + ']').addClass('active')

        target && $('#' + target).toggleClass('is-visible')
    })

    $('body').on('click', '.modal-tab-overlay, .modal-tab-close', function (e) {
        $(this)
            .parents('.modal-tab')
            .removeClass('is-visible')
    })

    $('[data-toggle-tab-modal]').click(function () {
        var insidetab = false

        if ($(this).hasClass('bottom-option-single')) {
            insidetab = true
            var tabContentSingle = $(this).attr('data-content')
            var tabContentWrap = $(this).parents('.tab-content')
            var tabWrap = tabContentWrap.parents('.modal-tab-content').find('.tab-wrap')
        } else if (!$(this).hasClass('tab-single')) {
            var target = $('#' + $(this).attr('data-target')).find('.tab-content')
            var nextElTab = target.find('.tab-single[data-content=' + tabContentSingle + ']')
        } else {
            var nextElTab = $(this)
        }
        if (!insidetab) {
            if (!nextElTab.hasClass('active')) {
                var tabWrap = nextElTab.parent()
                var tabContentSingle = nextElTab.attr('data-content')
                var tabContentWrap = tabWrap.siblings('.tab-content')

                if ($(this).hasClass('tab-single')) {
                    tabWrap.find('.tab-single.active').removeClass('active')
                    tabWrap
                        .find('.tab-single[data-content=' + tabContentSingle + ']')
                        .addClass('active')
                }

                tabWrap
                    .parent()
                    .find('.tab-content .tab-content-single.active')
                    .removeClass('active')
                tabWrap
                    .parent()
                    .find('.tab-content .tab-content-single[data-content=' + tabContentSingle + ']')
                    .addClass('active')
            }
        } else {
            tabWrap
                .parent()
                .find('.tab-content .tab-content-single.active')
                .removeClass('active')
            tabWrap
                .parent()
                .find('.tab-content .tab-content-single[data-content=' + tabContentSingle + ']')
                .addClass('active')
        }
    })
})
